import React from 'react';
import DenyPage from 'app/auth/deny';
import useBundleTranslation from 'i18n';
export default function Error404Page() {
    const { t } = useBundleTranslation(['app/error_page']);
    //ToDo separate UI blocks from DenyPage
    return <DenyPage type={'not_found'} info={{ message: t('message_404') }} />;
}
